import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import ActivitiesListPage from './activities/activities-list'
import ActivityCreatePage from './activities/activity-create'
import ActivityUpdatePage from './activities/activity-update'
import OlPersonalSpaceCenterDetails from './centers/ol-personal-space-center-details'
import OlPersonalSpaceCenterList from './centers/ol-personal-space-center-list'
import CoachCompaniesCreatePage from './coach-companies/coach-companies-create'
import CoachCompaniesListPage from './coach-companies/coach-companies-list'
import CoachCompaniesUpdatePage from './coach-companies/coach-companies-update'
import FeesListPage from './fees/fees-list'
import OlPersonalSPaceHostFamiliesListPage from './host-families/host-families-list'
import HostFamilyCreatePage from './host-families/host-family-create'
import HostFamilyUpdatePage from './host-families/host-family-update'
import MobileNumberForFrenchLeadersPage from './mobile-number-for-french-leaders/mobile-number-for-french-leaders'
import TeachingHallCreatePage from './teaching-halls/teaching-hall-create'
import TeachingHallUpdatePage from './teaching-halls/teaching-hall-update'
import TeachingHallsListPage from './teaching-halls/teaching-halls-list'
import TeflUpdatePage from './tefl/tef-update'
import TefelCreatePage from './tefl/tefl-create'
import TeflListPage from './tefl/tefl-list'

const olPersonalSpaceRoutes: Route[] = [
  {
    path: Paths.OL_PERSONAL_SPACE_HOST_FAMILIES_LIST_PAGE,
    element: <OlPersonalSPaceHostFamiliesListPage />,
    roles: [RoleEnum.Ol]
  },
  {
    path: Paths.OL_PERSONAL_SPACE_HOST_FAMILIES_CREATE_PAGE,
    roles: [RoleEnum.Ol],
    element: <HostFamilyCreatePage />
  },
  {
    path: Paths.OL_PERSONAL_SPACE_HOST_FAMILIES_UPDATE_PAGE,
    roles: [RoleEnum.Ol],
    element: <HostFamilyUpdatePage />
  },
  {
    path: Paths.OL_TEFL_LIST_PAGE,
    roles: [RoleEnum.Ol],
    element: <TeflListPage />
  },
  {
    path: Paths.OL_TEFL_CREATE_PAGE,
    roles: [RoleEnum.Ol],
    element: <TefelCreatePage />
  },
  {
    path: Paths.OL_TEFL_UPDATE_PAGE,
    roles: [RoleEnum.Ol],
    element: <TeflUpdatePage />
  },
  {
    path: Paths.OL_FEES_LIST_PAGE,
    element: <FeesListPage />,
    roles: [RoleEnum.Ol]
  },
  {
    path: Paths.TEACHING_HALLS_LIST_PAGE,
    element: <TeachingHallsListPage />,
    roles: [RoleEnum.Ol]
  },
  {
    path: Paths.TEACHING_HALL_CREATE_PAGE,
    roles: [RoleEnum.Ol],
    element: <TeachingHallCreatePage />
  },
  {
    path: Paths.TEACHING_HALL_UPDATE_PAGE,
    roles: [RoleEnum.Ol],
    element: <TeachingHallUpdatePage />
  },
  {
    path: Paths.OL_PERSONAL_SPACE_MOBILE_NUMBERS_FOR_FRENCH_LEADERS_LIST_PAGE,
    roles: [RoleEnum.Ol],
    element: <MobileNumberForFrenchLeadersPage />
  },
  {
    path: Paths.OL_PERSONAL_SPACE_ACTIVITY_LIST_PAGE,
    roles: [RoleEnum.Ol],
    element: <ActivitiesListPage />
  },
  {
    path: Paths.OL_PERSONAL_SPACE_ACTIVITY_CREATE_PAGE,
    roles: [RoleEnum.Ol],
    element: <ActivityCreatePage />
  },
  {
    path: Paths.OL_PERSONAL_SPACE_ACTIVITY_UPDATE_PAGE,
    roles: [RoleEnum.Ol],
    element: <ActivityUpdatePage />
  },
  {
    path: Paths.OL_PERSONAL_SPACE_COACH_COMPANIES_LIST_PAGE,
    roles: [RoleEnum.Ol],
    element: <CoachCompaniesListPage />
  },
  {
    path: Paths.OL_PERSONAL_SPACE_COACH_COMPANIES_CREATE_PAGE,
    roles: [RoleEnum.Ol],
    element: <CoachCompaniesCreatePage />
  },
  {
    path: Paths.OL_PERSONAL_SPACE_COACH_COMPANIES_UPDATE_PAGE,
    roles: [RoleEnum.Ol],
    element: <CoachCompaniesUpdatePage />
  },
  {
    path: Paths.OL_PERSONAL_SPACE_CENTER_LIST_PAGE,
    roles: [RoleEnum.Ol],
    element: <OlPersonalSpaceCenterList />
  },
  {
    path: Paths.OL_PERSONAL_SPACE_CENTER_DETAILS_PAGE,
    element: <OlPersonalSpaceCenterDetails />,
    roles: [RoleEnum.ADMIN, RoleEnum.Ol]
  }
]

export default olPersonalSpaceRoutes
